module.exports = __webpack_public_path__ + "static/img/bg-pt.2779e635.webp";